const handleVisibilityHidden = function (el, binding) {
  el.style.visibility = binding.value ? 'hidden' : '';
};

export const visibilityHidden = {
  beforeMount: handleVisibilityHidden,
  updated: handleVisibilityHidden,
  mounted: handleVisibilityHidden,
};
